import HomeDashboard from "./HomeDashboard";
import ProgramOverview from "./ProgramOverview";

export default function HomeTab({ program }) {
    return (
        <div>
            <HomeDashboard programId={program.id}/>
            <div className="v-spacer-xs"></div>
            <ProgramOverview program={program} isExpanded={true}/>
            <div className="v-spacer-3xl"></div>
        </div>
    )
}
